import React from 'react';
import {ReactComponent as EditIcon} from '../../../../../../assets/main/groups/main-top/edit.svg';
import {useAppSelector} from "common/hook";
import {NavLink, useParams} from "react-router-dom";
import {ROLE_TEACHER} from "entities/constants/constants";

export const OnlineEditTest = () => {
    const {testId} = useParams()
    const roleType = useAppSelector((state) => state.role.roleType);
    const testData = useAppSelector(state => state.getTests.model)
    return (
        <NavLink className='no-hover' to={`/test/test-edit/${testId}`}>
            {(roleType === ROLE_TEACHER && testData.canEdit) ?
                <span className="edit-lesson-btn p-icon pointer-elem control-btn">
                     <span className="text">Редактировать тест</span>
                     <span className="icon"><EditIcon/></span>
            </span>
                :
                null
            }
        </NavLink>
    );
};
